const queryString = ((a) => {
  if (a === '') return {};
  const b = {};
  for (let i = 0; i < a.length; ++i) {
    const p = a[i].split('=', 2);
    if (p.length === 1) {
      b[p[0]] = '';
    } else {
      b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' ')) + window.location.hash;
    }
  }
  return b;
})(window.location.search.substr(1).split('&'));

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
function detectIE() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return true;
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    return false;
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return false;
  }

  // other browser
  return false;
}

function isOkPass(p) {
  const anUpperCase = /[A-Z]/;
  const aLowerCase = /[a-z]/;
  const aNumber = /[0-9]/;
  const obj = {};
  obj.result = true;

  if (p.length < 8) {
    obj.result = false;
    obj.error = 'Must be longer than 8 characters';
    return obj;
  }

  let numUpper = 0;
  let numLower = 0;
  let numNums = 0;

  for (let i = 0; i < p.length; i++) {
    if (anUpperCase.test(p[i])) {
      numUpper++;
    } else if (aLowerCase.test(p[i])) {
      numLower++;
    } else if (aNumber.test(p[i])) {
      numNums++;
    }
  }

  if (numUpper < 1 || numLower < 1 || numNums < 1) {
    obj.result = false;
    obj.error = 'Wrong Format!';
    return obj;
  }
  return obj;
}
export default {
  queryString,
  isOkPass,
  detectIE,
};



// WEBPACK FOOTER //
// ./src/util.js